(function () {
  // Which products are gated is no longer hardcoded here - it's driven by the
  // "prescription-required" tag on each product (set in Shopify admin) and
  // rendered into window.__miGateProduct by a small snippet in theme.liquid,
  // right before this script tag. This means tagging a product
  // "prescription-required" is enough to bring it under this gate - no code
  // change needed here when a new product launches. See isGatedProductPage().
  var TERMS_VERSION = "2026-08-29-v1";
  var HULK_SUCCESS_PHRASE = 'form has been submitted';
  var HULK_IFRAME_HOST = 'formbuilder.hulkapps.com';
  var DEBUG = true; // TEMP: logs "[MI Gate] ..." to the console on gated product pages only.
                     // Safe to leave on - remove once the fix is confirmed working live.

  var state = window.__miGateState = window.__miGateState || { termsOk: false, hulkOk: false, termsAcceptedAt: '' };

  var pendingErrorBox = null;
  var pendingWrap = null;

  function log() {
    if (DEBUG && window.console && isGatedProductPage()) {
      var args = ['[MI Gate]'].concat(Array.prototype.slice.call(arguments));
      console.log.apply(console, args);
    }
  }

  function isGatedProductPage() {
    // window.__miGateProduct is set by theme.liquid, right before this script
    // loads, from the current product's own tags - so this is correct on
    // every page load with no path/handle parsing (and no risk of the old
    // handle-vs-URL mismatch bug that silently broke Mission Brief's gate).
    return !!(window.__miGateProduct && window.__miGateProduct.prescriptionRequired);
  }

  function isReady() {
    return state.termsOk && state.hulkOk;
  }

  function currentErrorMessage() {
    if (!state.termsOk && !state.hulkOk) {
      return "Please accept the Terms & Conditions and complete the prescription form below (select an option and click Submit) before adding this product to your cart.";
    } else if (!state.termsOk) {
      return "Please confirm you've read and accept the Terms & Conditions before adding this product to your cart.";
    } else {
      return "Please select an option in the prescription form below and click Submit before adding this product to your cart.";
    }
  }

  // Called when a blocked Add to Cart / Submit attempt happens: shows the message and
  // scrolls it into view.
  function showError() {
    var msg = currentErrorMessage();
    if (pendingErrorBox) {
      pendingErrorBox.textContent = msg;
      pendingErrorBox.style.display = 'block';
    } else if (isGatedProductPage()) {
      window.alert(msg);
    }
    if (pendingWrap && pendingWrap.scrollIntoView) pendingWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // Keeps an already-visible error message in sync with the current state, so toggling
  // the checkbox or completing the Hulk form updates (or clears) the message immediately
  // instead of leaving stale text from an earlier attempt. Never scrolls - this only
  // reacts to state changes, not to a fresh blocked attempt.
  function refreshErrorIfVisible() {
    if (!pendingErrorBox || pendingErrorBox.style.display === 'none') return;
    if (isReady()) {
      pendingErrorBox.style.display = 'none';
      return;
    }
    pendingErrorBox.textContent = currentErrorMessage();
  }

  // Only ever touches the Shopify cart form's DOM at the exact moment a valid
  // submission is being allowed through - never proactively, so it can't interfere
  // with the theme's own form/component state at any other time.
  function ensureHiddenFieldsOnForm(form) {
    var fields = {
      'properties[Terms Accepted]': state.termsOk ? 'Yes' : 'No',
      'properties[Terms Version]': TERMS_VERSION,
      'properties[Terms Accepted At]': state.termsAcceptedAt || '',
      'properties[Prescription Form Submitted]': state.hulkOk ? 'Yes' : 'No'
    };
    Object.keys(fields).forEach(function (name) {
      var input = form.querySelector('input[data-mi-terms-field="' + name + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.setAttribute('data-mi-terms-field', name);
        input.name = name;
        form.appendChild(input);
      }
      input.value = fields[name];
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!isGatedProductPage()) return;
    if (!isReady()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showError();
    } else {
      ensureHiddenFieldsOnForm(form);
    }
  }, true);

  document.addEventListener('click', function (event) {
    var submitControl = event.target && event.target.closest ? event.target.closest('button[name="add"]') : null;
    if (!submitControl) return;
    var form = submitControl.closest('form[action*="/cart/add"]');
    if (!form) return;
    if (!isGatedProductPage()) return;
    if (!isReady()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      showError();
    }
  }, true);

  function injectWidget() {
    if (!isGatedProductPage()) return;
    if (document.getElementById('mi-terms-consent-global')) return;

    var container = document.querySelector('.product-form-buttons');
    if (!container || !container.parentNode) return;

    var wrap = document.createElement('div');
    wrap.className = 'mi-terms-consent';
    wrap.id = 'mi-terms-consent-global';
    wrap.style.cssText = 'margin-block:14px 6px;padding:14px 16px;border:1px solid rgba(255,255,255,0.25);border-radius:6px;background:rgba(255,255,255,0.04);';
    wrap.innerHTML =
      '<label style="display:flex;align-items:flex-start;gap:10px;cursor:pointer;font-size:0.85rem;line-height:1.45;">' +
        '<input type="checkbox" id="mi-terms-checkbox-global" style="margin-top:3px;width:16px;height:16px;flex-shrink:0;">' +
        '<span>I confirm I am the prescribed patient (or purchasing strictly on the prescribed patient\'s behalf), and I have read and agree to Moon Impact\'s <a href="/policies/terms-of-service" target="_blank" rel="noopener" style="text-decoration:underline;">Terms &amp; Conditions and Patient Consent</a>. This product is for prescription-directed use only.</span>' +
      '</label>' +
      '<div id="mi-terms-error-global" style="display:none;color:#ff6b6b;font-size:0.8rem;margin-top:6px;"></div>';

    container.parentNode.insertBefore(wrap, container);

    var checkbox = document.getElementById('mi-terms-checkbox-global');
    var errorBox = document.getElementById('mi-terms-error-global');
    pendingErrorBox = errorBox;
    pendingWrap = wrap;

    checkbox.addEventListener('change', function () {
      state.termsOk = checkbox.checked;
      state.termsAcceptedAt = checkbox.checked ? new Date().toISOString() : '';
      refreshErrorIfVisible();
    });
  }

  // ---- Same-document text-scan fallback (kept for safety / future-proofing) ----
  // NOTE: this only works if the Hulk widget is ever rendered in the SAME origin
  // as the storefront page. Today it is not (see below), so this check will
  // never fire on this store - it's a harmless no-op fallback, not the fix.
  function checkHulkSuccess() {
    if (state.hulkOk) return;
    if (!isGatedProductPage()) return;
    var bodyText = document.body.innerText || document.body.textContent || '';
    if (bodyText.toLowerCase().indexOf(HULK_SUCCESS_PHRASE) !== -1) {
      log('same-document text match found (unexpected on this store, but handling it)');
      state.hulkOk = true;
      refreshErrorIfVisible();
    }
  }

  var hulkCheckScheduled = false;
  function scheduleHulkCheck() {
    if (hulkCheckScheduled || state.hulkOk) return;
    hulkCheckScheduled = true;
    setTimeout(function () {
      hulkCheckScheduled = false;
      checkHulkSuccess();
    }, 200);
  }

  function observeHulkForm() {
    if (!isGatedProductPage()) return;
    if (!document.body) return;
    var observer = new MutationObserver(scheduleHulkCheck);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true });
    checkHulkSuccess();
  }

  // ---- Real fix: cross-origin-safe Hulk submission detector ----
  //
  // Root cause of the bug this replaces: Hulk's prescription form renders
  // inside an <iframe src="https://formbuilder.hulkapps.com/..."> - a
  // DIFFERENT origin from this storefront. Browsers block a page from
  // reading ANY content inside a cross-origin iframe (that's the whole
  // point of the Same-Origin Policy), so document.body.innerText on this
  // page can NEVER contain the iframe's "Your form has been submitted..."
  // text, no matter how fast or how long we poll for it. Verified directly:
  // a full-document text search (including shadow DOM) for both "choose
  // prescription" and "form has been submitted" finds nothing outside the
  // iframe - confirmed by inspecting the live page.
  //
  // What we CAN read, cross-origin restrictions or not, is the <iframe>
  // element itself sitting in OUR page - specifically its own `style`
  // attribute. Hulk's own connector script (form-builder-script.js, loaded
  // in the parent page, not inside the iframe) listens for postMessage from
  // the iframe and sets `iframe.style.height = <n>px` to fit the iframe to
  // its current content. The multi-field prescription form is tall; the
  // "thank you" confirmation view Hulk swaps in after a successful submit
  // is much shorter. So a real, sustained height drop after the full form
  // has rendered is a reliable, purely same-origin signal that the visitor
  // submitted the form - without ever needing to see inside the iframe.
  var hulkIframeObserver = null;
  var hulkMaxHeightSeen = 0;

  function findHulkIframe() {
    return document.querySelector('iframe[src*="' + HULK_IFRAME_HOST + '"]');
  }

  function handleHulkIframeHeight(iframe) {
    var h = parseInt(iframe.style.height, 10) || 0;
    if (h <= 0) return;
    if (h > hulkMaxHeightSeen) {
      hulkMaxHeightSeen = h;
      log('Hulk iframe height ->', h, '(new max)');
      return;
    }
    log('Hulk iframe height ->', h, '(max seen:', hulkMaxHeightSeen, ')');
    // Require we've actually seen a "real form" height first (avoids
    // treating the very first small placeholder height as a false drop),
    // then look for a solid drop from that peak.
    if (hulkMaxHeightSeen >= 150 && h <= hulkMaxHeightSeen * 0.6) {
      log('height drop detected - treating prescription form as submitted');
      state.hulkOk = true;
      refreshErrorIfVisible();
    }
  }

  function observeHulkIframe() {
    if (!isGatedProductPage() || state.hulkOk) return;
    var iframe = findHulkIframe();
    if (!iframe) {
      // Hulk injects its iframe asynchronously - keep checking until it shows up.
      setTimeout(observeHulkIframe, 300);
      return;
    }
    if (hulkIframeObserver) return; // already watching this iframe
    log('found Hulk iframe, watching for height changes', iframe.id);
    handleHulkIframeHeight(iframe);
    hulkIframeObserver = new MutationObserver(function () {
      handleHulkIframeHeight(iframe);
    });
    hulkIframeObserver.observe(iframe, { attributes: true, attributeFilter: ['style'] });
  }

  function init() {
    injectWidget();
    observeHulkForm();
    observeHulkIframe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('page:loaded', init);
  document.addEventListener('shopify:section:load', init);
})();
